module.exports = __webpack_public_path__ + "img/logo-350px_red.0d3147a3.png";